module.exports = __webpack_public_path__ + "media/src/images/mails/green_tick@2x-17c886f19e31aa7275732916d48f2b2a.png";